import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/imgs/dynamicTopicImg/ic_add.png';

const _withScopeId = n => (_pushScopeId("data-v-e791acd8"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "module_header"
};
const _hoisted_2 = {
  class: "text"
};
const _hoisted_3 = ["onClick"];

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));

const _hoisted_5 = [_hoisted_4];
const _hoisted_6 = {
  class: "module_content"
};
const _hoisted_7 = ["src"];
import { getTextWidth } from '@/utils';
export default /*#__PURE__*/_defineComponent({
  __name: 'TemplateList',
  props: {
    typeKey: {
      type: String,
      required: true
    },
    controls: {
      type: Array,
      required: true
    }
  },
  emits: 'add-template',

  setup(__props, {
    emit: emits
  }) {
    const props = __props;

    const addTemplate = control => {
      emits('add-template', props.typeKey, control);
    }; //  内容超出时显示提示


    const tipDisabled = ref(false);

    const showTextTip = e => {
      const target = e.target;
      const width = getTextWidth(target.innerText);
      tipDisabled.value = target.offsetWidth < width;
    };

    return (_ctx, _cache) => {
      const _component_MPopper = _resolveComponent("MPopper");

      return _openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.controls, (control, controlKey) => {
        return _openBlock(), _createElementBlock("div", {
          class: "template_module",
          key: controlKey
        }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_MPopper, {
          disabled: tipDisabled.value,
          placement: "top",
          trigger: "hover",
          content: control.name
        }, {
          reference: _withCtx(() => [_createElementVNode("span", {
            onMouseover: showTextTip,
            class: "item-name"
          }, _toDisplayString(_ctx.$t('名称') + ':' + control.name), 33)]),
          _: 2
        }, 1032, ["disabled", "content"])]), _createElementVNode("div", {
          class: "add_btn",
          onClick: $event => addTemplate(control)
        }, _hoisted_5, 8, _hoisted_3)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("img", {
          src: control.layoutImage,
          alt: ""
        }, null, 8, _hoisted_7)])]);
      }), 128);
    };
  }

});